import React, { useEffect, useMemo, useState } from "react"
import { map, find, get, compact, isEmpty } from "lodash"
import ClassNames from "classnames"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"

import * as Formatter from "utils/Formatter"
import PushSymbol from "../pushSymbol"
import { GetTicketKey } from "../../../node-dist/nodeDistFlag"
import { checkNoneData } from "utils/util"
import { useSelector } from "react-redux"
import { LoadStateType } from "redux/ducks/PageLoad"
import { history } from "config/const"
import { useChangeMenuTrigger } from "components/actions/customHook/changeMenu"
import { useEffectFirstSkip } from "components/actions/customHook/useEffectFirstSkip"
import { ReduxSymbolDetailStateType } from "redux/ducks/SymbolDetail"
import { Config } from "config/config"
import { EXCHANGE } from "config/const"

interface list {
  SymbolName: string
  Price: string
  ChangedPrice?: string
  PriceTime: string
}
interface tickerItemProps {
  list: list
  pushSymbol?: object
  dataPush?: object
}
interface tickerProps {
  list: Array<list>
}

const TickerItem = ({
  list: symbol,
  pushSymbol,
  dataPush,
}: tickerItemProps) => {
  const { Price, NumberOfDecimals, ChangedPrice, PriceTime } = useMemo(() => {
    const Price = !isEmpty(pushSymbol)
      ? get(pushSymbol, "Price")
      : get(symbol, "Price")
    const NumberOfDecimals = get(symbol, "NumberOfDecimals")
    const ChangedPrice = !isEmpty(pushSymbol)
      ? get(pushSymbol, "ChangedPrice")
      : get(symbol, "ChangedPrice")
    const PriceTime = !isEmpty(pushSymbol)
      ? get(pushSymbol, "PriceTime")
      : get(symbol, "PriceTime")
    return {
      Price,
      NumberOfDecimals,
      ChangedPrice,
      PriceTime,
    }
  }, [pushSymbol, symbol])
  return (
    <li {...dataPush}>
      {/* TODO:・右パーツのデフォルトが日経平均指数であるが、一度先物などに変えると戻せない、上部の指数エリアも選択できるように */}
      {/* <li onClick={dispatch(changeSymbol(props.canvasId, data))}> */}
      <div className="header-index-title">{symbol.SymbolName}</div>
      <div className="header-index-price">
        {Formatter.number(Price, NumberOfDecimals, "floor", false, "-")}
      </div>
      {/*{ChangedPrice ? (*/}
      <div
        className={ClassNames(
          "header-index-chang",
          Formatter.upDown(ChangedPrice)
        )}
      >
        {Formatter.number(ChangedPrice, NumberOfDecimals, "floor", true)}
      </div>
      {/*) : null}*/}
      <div className="header-index-time">
        {Formatter.date(PriceTime, "HH:mm")}
      </div>
    </li>
  )
}
export const Ticker = (props: {
  isPush?: boolean
  history?: history
  effectItem?: { effect: boolean; setEffect: Function }
}) => {
  const [list, setList] = useState()
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )
  const isSymbolDetailPageLoading = useSelector(
    (state: { symbolDetail: ReduxSymbolDetailStateType }) => {
      return state.symbolDetail.refresh
    }
  )
  const { _changeMenuTrigger } = useChangeMenuTrigger()
  const location = get(props.history, "location")
  const effect = get(props.effectItem, "effect")

  const callApi = async () => {
    const res: APIResponse.Res = await APIs.SymbolDetail.PriceList({
      Name: `Top.Panel.Header`,
    })
    setList(get(res, "ResultList"))
  }

  useEffect(() => {
    callApi()
    // let polling = setInterval(() => {
    //   callApi()
    // }, Config.api.tickerPollingInterval)
    // return () => {
    //   clearInterval(polling)
    // }
  }, [])

  useEffectFirstSkip(() => {
    if (!location) return
    const pathName = compact(get(location, "pathname").split("/"))
    if (
      pathName[0] === "news" ||
      (pathName.length !== 1 && !_changeMenuTrigger.changeMenuFlag)
    ) {
      callApi()
    }
  }, [location])

  useEffectFirstSkip(() => {
    if (effect) {
      callApi()
      props.effectItem.setEffect(false)
    }
  }, [effect])

  useEffect(() => {
    isPageLoading && callApi()
  }, [isPageLoading])

  useEffectFirstSkip(() => {
    !props.isPush && callApi()
  }, [props.isPush])

  useEffect(() => {
    isSymbolDetailPageLoading && callApi()
  }, [isSymbolDetailPageLoading])
  return (
    <ul className="header-index">
      {map(list, (val, i) =>
        !props.isPush || get(val, "Exchange") === EXCHANGE.FX.id ? (
          <TickerItem list={val} key={i} />
        ) : (
          <PushSymbol
            apiSymbol={val}
            ticketKey={GetTicketKey(val)}
            renderingId={i}
            renderer={(push: any, apiSymbol: any, dataPush: any) => {
              return (
                <TickerItem
                  list={apiSymbol}
                  pushSymbol={push}
                  dataPush={dataPush}
                  key={i}
                />
              )
            }}
          />
        )
      )}
    </ul>
  )
}

//自動で動くサンプル
// const TickerItem = ({ list, position }: tickerItemProps) => (
//   <li style={{ left: `${position}px` }}>
//     <div className="header-nav-index-list-row">
//       <div className="header-nav-index-title">{list.title}</div>
//       <div className="header-nav-index-price">{list.price}</div>
//       {list.changePrice ? (
//         <div className="header-nav-index-change-price up">
//           {list.changePrice}
//         </div>
//       ) : null}
//       <div className="header-nav-index-time time-col">{list.time}</div>
//     </div>
//   </li>
// )
// export const Ticker = ({ list }: tickerProps) => {
//   const itemWidth = 180
//   const fullWidth = 1440
//   const ulWidth = list.length * itemWidth
//   const [moveState, switchMoveState] = useState(true)
//   const [itemPos, setItemPos] = useState<Array<number>>(
//     map(list, (val, i) => i * itemWidth)
//   )
//   requestAnimationFrame(() => {
//     if (!moveState || moveState) return
//     const newPos = map(itemPos, val => {
//       const movePos = fullWidth > ulWidth ? fullWidth : ulWidth - itemWidth
//       return val < -1 * itemWidth ? movePos : val - 2
//     })
//     setItemPos(newPos)
//   })
//   const hoverHandler = () => {
//     switchMoveState(!moveState)
//   }
//   return (
//     <div
//       onMouseLeave={hoverHandler}
//       onMouseEnter={hoverHandler}
//       className="infinite-slide-wrap"
//     >
//       <ul className="header-nav-index-list infinite-slide">
//         {map(list, (val, i) => (
//           <TickerItem list={val} position={itemPos[i]} key={i} />
//         ))}
//       </ul>
//     </div>
//   )
// }
